import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
export type ShimmerProps = HTMLAttributes<HTMLDivElement> & {
  height?: string | number;
  width?: string | number;
};
const Shimmer = t0 => {
  const $ = _c(20);
  let ariaHidden;
  let className;
  let height;
  let props;
  let style;
  let t1;
  let width;
  if ($[0] !== t0) {
    ({
      "aria-hidden": ariaHidden,
      "aria-valuetext": t1,
      className,
      height,
      width,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = ariaHidden;
    $[2] = className;
    $[3] = height;
    $[4] = props;
    $[5] = style;
    $[6] = t1;
    $[7] = width;
  } else {
    ariaHidden = $[1];
    className = $[2];
    height = $[3];
    props = $[4];
    style = $[5];
    t1 = $[6];
    width = $[7];
  }
  const ariaValueText = t1 === undefined ? "Loading..." : t1;
  let t2;
  if ($[8] !== className) {
    t2 = cx("fp-shimmer", className);
    $[8] = className;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== height || $[11] !== style || $[12] !== width) {
    t3 = {
      height,
      width,
      ...style
    };
    $[10] = height;
    $[11] = style;
    $[12] = width;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== ariaHidden || $[15] !== ariaValueText || $[16] !== props || $[17] !== t2 || $[18] !== t3) {
    t4 = <div className={t2} aria-busy="true" aria-hidden={ariaHidden} aria-valuemax={100} aria-valuemin={0} aria-valuetext={ariaValueText} role="progressbar" style={t3} {...props} />;
    $[14] = ariaHidden;
    $[15] = ariaValueText;
    $[16] = props;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
};
export default Shimmer;